import { render, staticRenderFns } from "./FormularioUsuarios.vue?vue&type=template&id=60aea22e&"
import script from "./FormularioUsuarios.vue?vue&type=script&lang=js&"
export * from "./FormularioUsuarios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports